/* Serialize writes. Aborting an HTTP request cannot undo a Shopify cart change. */
(() => {
  if (window.CnCartOperations) return;
  const locked = new Map();
  const wallets = new Map();
  const queue = window.CnCartOperations = {
    tail: Promise.resolve(), pending: 0, revision: 0, intents: new Map(),
    enqueue(task) {
      this.pending += 1;
      this.revision += 1;
      syncCheckout();
      const result = this.tail.catch(() => {}).then(task);
      this.tail = result.catch(() => {});
      result.finally(() => { this.pending -= 1; syncCheckout(); }).catch(() => {});
      return result;
    },
    async whenIdle() {
      await this.tail;
      if (this.pending) return this.whenIdle();
    },
  };
  function syncCheckout() {
    if (queue.pending) {
      document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach(button => {
        if (!locked.has(button)) locked.set(button, button.disabled);
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      });
      document.querySelectorAll('.additional-checkout-buttons').forEach(wrapper => {
        if (!wallets.has(wrapper)) wallets.set(wrapper, wrapper.hasAttribute('inert'));
        wrapper.setAttribute('inert', '');
        wrapper.setAttribute('aria-busy', 'true');
      });
    } else {
      locked.forEach((disabled, button) => { button.disabled = disabled; button.removeAttribute('aria-busy'); });
      locked.clear();
      wallets.forEach((inert, wrapper) => { wrapper.toggleAttribute('inert', inert); wrapper.removeAttribute('aria-busy'); });
      wallets.clear();
    }
  }
  document.addEventListener('submit', event => {
    if (queue.pending && event.submitter?.name === 'checkout') event.preventDefault();
  }, true);
  document.addEventListener('click', event => {
    if (queue.pending && event.target.closest?.('.additional-checkout-buttons')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  new MutationObserver(() => { if (queue.pending) syncCheckout(); }).observe(document.documentElement, {childList:true,subtree:true});
})();
